import {
    getProduct,
    listProducts
} from './queries';
import {
    cloneProduct,
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CloneProduct,
    CreateProduct,
    DeleteProduct,
    GetProduct,
    ListProducts,
    Product,
    UpdateProduct
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

const normalizeRecord = (record: Product) => {
    return Object.assign({}, record);
};


const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {

    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                          query: listProducts,
                                                                          variables: {
                                                                              ...rest,
                                                                              ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                          },
                                                                      });

    return {
        items: response.data?.listProducts.items?.map(item => normalizeRecord(item)) || [],
        nextToken: response.data?.listProducts.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                        query: getProduct,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getProduct;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateProduct>>({
                                                                           query: createProduct,
                                                                           variables: {input: payload},
                                                                       });
    return response.data?.createProduct;
};

export const update = async (_id: string, record: Product) => {

    // `record` is the whitelisted UpdateProductInput from buildUpdateProductInput (§6).
    // The old `delete record.created ...` lines mutated whatever the caller passed and
    // removed keys the builder never sets, so they are gone; the payload is unchanged.
    // ⚠️ Empty values are still dropped: an optional field cannot be cleared from here
    // (out of scope for FNP-1898, it changes what a save sends).
    // Filter out null/undefined values
    const cleanRecord = Object.fromEntries(
        Object.entries(record).filter(([_key, value]) => value !== null && value !== undefined && value !== '')
    );

    const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
                                                                           query: (updateProduct),
                                                                           variables: {input: cleanRecord},
                                                                       });
    return response.data?.updateProduct;
};

export const cloneRecord = async (id: string) => {

    const response = await client.graphql<GraphQLQuery<CloneProduct>>({
                                                                          query: (cloneProduct),
                                                                          variables: {id: id},
                                                                      });
    return response.data?.cloneProduct;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
                                                                           query: (deleteProduct),
                                                                           variables: {input: {id: id}},

                                                                       });
    return response.data?.deleteProduct;
};
